import React, { useState } from "react";
import { AlertBox, Header } from "../components";
import { useNavigate } from "react-router-dom";

import { FaChevronLeft, FaCheck } from "react-icons/fa";
import { useStateContext } from "../contexts/ContextProvider";
import Button from "../components/Button";

const ManageSubscription = () => {
  const { stripeSubscription, alert, handleAlert } = useStateContext();
  const [newSubscription, setNewSubscription] = useState("");
  const navigate = useNavigate();

  const handleSubscription = (subscriptionType) => {
    if (stripeSubscription.type === "founder") {
      setNewSubscription(subscriptionType);
      handleAlert("changeSubscription");
      return;
    }
    navigate(`/checkout-subscription/${subscriptionType}`);
  };

  return (
    <div>
      {alert.changeSubscription && (
        <AlertBox
          alertType="changeSubscription"
          handleAlert={handleAlert}
          alertFunc={() => {
            navigate(`/checkout-subscription/${newSubscription}`);
          }}
        />
      )}
      <section id="header" className="w-screen">
        <Header />
      </section>
      <section
        id="subscription"
        className="fixed left-0 right-0 top-20 bottom-0"
      >
        <div
          className="flex items-center h-10 bg-snappily-orange border-gray-300 
                  border-t-1 text-xl text-white p-3 gap-x-3 cursor-pointer z-20"
          onClick={() => navigate(-1)}
        >
          <FaChevronLeft />
          Back
        </div>
        <div className="h-full overflow-hidden overflow-y-scroll pb-40">
          <div className="flex justify-center text-2xl mt-5">
            Manage Subscription
          </div>
          <div className="grid lg:flex lg:justify-center lg:gap-x-5">
            <div className="flex justify-center mt-5 relative h-[525px]">
              <div
                className={`w-80 rounded-xl p-5 ${
                  stripeSubscription.type === "basic"
                    ? "border-4 border-snappily-orange"
                    : "border-2 border-gray-300"
                }`}
              >
                <div className="flex justify-center text-2xl">Basic</div>
                <div className="flex justify-center text-7xl mt-5">FREE</div>
                <div className="flex justify-center text-center mt-5 px-5">
                  Try before you buy!
                </div>
                {/* <div className="flex justify-center text-base text-green-400 mt-10">
                  ($14/mth Annually - Save 30%)
                </div> */}
                <div className="flex justify-center text-base text-center text-gray-400 mt-10">
                  Perfect for turning a vacant bedroom into extra cash!
                </div>
                <div className="flex justify-center text-lg mt-5">
                  INCLUDES:
                </div>
                <div className="flex justify-center">
                  <div className="text-sm">
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>
                        Support for
                        <span className="text-blue-500 mx-1">ONE</span>
                        Tenant
                      </div>
                    </div>
                    <div className="flex justify-start items-center ">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>Leases Optimized For Every State</div>
                    </div>
                    <div className="flex justify-start items-center ">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>Split Bills, and Assign Chores</div>
                    </div>
                    <div className="flex justify-start items-center ">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>In-App Messaging</div>
                    </div>
                  </div>
                </div>
                <div className=" w-full flex justify-center mt-10 lg:absolute bottom-10 right-0">
                  <Button
                    background={
                      stripeSubscription.type === "basic"
                        ? "bg-white"
                        : "bg-snappily-orange"
                    }
                    text={
                      stripeSubscription.type === "basic"
                        ? "text-snappily-orange"
                        : "text-white"
                    }
                    opacity="bg-opacity-100"
                    title={
                      stripeSubscription.type === "basic"
                        ? "Current Plan"
                        : "Select"
                    }
                    height="h-10"
                    width="w-60"
                    borderHover="hover:border-snappily-orange"
                    customFunc={
                      stripeSubscription.type === "basic"
                        ? () => {}
                        : () => handleSubscription("basic")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-5 relative">
              <div
                className={`w-80 rounded-xl p-5 ${
                  stripeSubscription.type === "premium" ||
                  stripeSubscription.type === "founder"
                    ? "border-2 border-snappily-orange"
                    : "border-2 border-gray-300"
                }`}
              >
                <div className="flex justify-center text-2xl">Premium</div>
                <div className="flex justify-center text-7xl mt-5">$19.99</div>
                <div className="flex justify-center mt-0">/month</div>
                {/* <div className="flex justify-center text-center mt-5 px-5">
                  *Plus 2% of electronic payments received.
                </div> */}
                <div className="flex justify-center text-base text-green-400 mt-5">
                  ($14/mth Annually - Save 30%)
                </div>
                <div className="flex justify-center text-base text-center text-gray-400 mt-5">
                  Perfect for managing multiple roommates with ease!
                </div>
                <div className="flex justify-center text-lg mt-5">
                  INCLUDES:
                </div>
                <div className="flex justify-center">
                  <div className="text-sm">
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>All Basic Features, Plus...</div>
                    </div>
                    {/* <div className="flex justify-start items-center ">
                    <FaCheck className="text-snappily-green mr-2" />
                    <div>Collect Rent Electronically (ACH)</div>
                  </div> */}
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>
                        Support for up to
                        <span className="text-blue-500 mx-1">Four</span>
                        Tenants
                      </div>
                    </div>
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>
                        Support for
                        <span className="text-blue-500 mx-1">Two</span>
                        Properties
                      </div>
                    </div>
                    <div className="flex justify-start items-center ">
                      <FaCheck className=" text-center text-snappily-green mr-2" />
                      <div>Expense Tracking and Reporting</div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-center mt-10 lg:absolute bottom-10 right-0">
                  <Button
                    background={
                      stripeSubscription.type === "premium" ||
                      stripeSubscription.type === "founder"
                        ? "bg-white"
                        : "bg-snappily-orange"
                    }
                    text={
                      stripeSubscription.type === "premium" ||
                      stripeSubscription.type === "founder"
                        ? "text-snappily-orange"
                        : "text-white"
                    }
                    opacity="bg-opacity-100"
                    title={
                      stripeSubscription.type === "premium" ||
                      stripeSubscription.type === "founder"
                        ? "Current Plan"
                        : "Select"
                    }
                    height="h-10"
                    width="w-60"
                    borderHover="hover:border-snappily-orange"
                    customFunc={
                      stripeSubscription.type === "premium" ||
                      stripeSubscription.type === "founder"
                        ? () => {}
                        : () => handleSubscription("premium")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-5">
              <div
                className={`w-80 rounded-xl p-5 relative ${
                  stripeSubscription.type === "professional"
                    ? "border-2 border-snappily-orange"
                    : "border-2 border-gray-300"
                }`}
              >
                <div className="flex justify-center text-2xl">Professional</div>
                <div className="flex justify-center text-7xl mt-5">$49.99</div>
                <div className="flex justify-center mt-0">/month</div>
                {/* <div className="flex justify-center text-center mt-5 px-5">
                  *Plus 2% of electronic payments received.
                </div> */}
                <div className="flex justify-center  tex-center text-lg text-green-400 mt-5">
                  ($25/mth Annually - Save 50%)
                </div>
                <div className="flex justify-center text-base text-center text-gray-400 mt-5">
                  Perfect for managing multiple properties, with multiple
                  tenants!
                </div>
                <div className="flex justify-center text-lg mt-5">
                  INCLUDES:
                </div>
                <div className="flex justify-center">
                  <div className="text-sm">
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>All Premium Features, Plus...</div>
                    </div>
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>
                        Support for
                        <span className="text-blue-500 mx-1">Unlimited</span>
                        Tenants
                      </div>
                    </div>
                    <div className="flex justify-start items-center">
                      <FaCheck className="text-snappily-green mr-2" />
                      <div>
                        Support for
                        <span className="text-blue-500 mx-1">Unlimited</span>
                        Properties
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-full flex justify-center mt-10 lg:absolute bottom-10 right-0">
                  <Button
                    background={
                      stripeSubscription.type === "professional"
                        ? "bg-white"
                        : "bg-snappily-orange"
                    }
                    text={
                      stripeSubscription.type === "professional"
                        ? "text-snappily-orange"
                        : "text-white"
                    }
                    opacity="bg-opacity-100"
                    title={
                      stripeSubscription.type === "professional"
                        ? "Current Plan"
                        : "Select"
                    }
                    height="h-10"
                    width="w-60"
                    borderHover="hover:border-snappily-orange"
                    customFunc={
                      stripeSubscription.type === "professional"
                        ? () => {}
                        : () => handleSubscription("professional")
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageSubscription;
